import api from './api';

export const dashboardService = {
  getPipeline: (productId?: number) =>
    api.get('/dashboard/pipeline', { params: productId ? { productId } : {} }).then((r) => r.data),
  getConversion: (productId?: number, months?: number) =>
    api.get('/dashboard/conversion', { params: { productId, months } }).then((r) => r.data),
  getRevenue: (productId?: number, months?: number) =>
    api.get('/dashboard/revenue', { params: { productId, months } }).then((r) => r.data),
  getLost: (productId?: number, months?: number) =>
    api.get('/dashboard/lost', { params: { productId, months } }).then((r) => r.data),
  getSummary: (productId?: number) =>
    api.get('/dashboard/summary', { params: productId ? { productId } : {} }).then((r) => r.data),
};
